import { PDFDocument, StandardFonts } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
import { drawTextOnPage, truncateText } from "./StaticPdfUtils";

// PDF Path
const PDF = "/static/pdf/printList/graphic_sheet.pdf";
const Font = "/static/fonts/THSarabunNew-Bold.ttf"; //* กรณีแก้ Font

const FormGraphicSheet = async (props: any) => {
  try {
    const existingPdfBytes = await fetch(PDF).then((res) => res.arrayBuffer());
    const pdfDoc = await PDFDocument.load(existingPdfBytes);

    // Loading Custom Font
    const fontUrl = Font;
    const fontBytes = await fetch(fontUrl).then((res) => res.arrayBuffer());
    pdfDoc.registerFontkit(fontkit);
    const customFont = await pdfDoc.embedFont(fontBytes);
    const zapFont = await pdfDoc.embedFont(StandardFonts.ZapfDingbats);

    const pages = pdfDoc.getPages();
    const fontSize = 11; //*

    // Page 1
    const pageOneCoordinates = [
      { text: props.items?.patientFullName, x: 380, y: 823 },
      { text: props.items?.hn, x: 524, y: 823 },
      { text: props.items?.birthdateAd, x: 396, y: 809 },
      { text: props.items?.age.toString(), x: 474, y: 809 },
      { text: props.items?.formatGender, x: 534, y: 809 },
      { text: props.items?.patientEncounter, x: 393, y: 793 },
      { text: props.items?.formatVisitDate, x: 500, y: 793 },
      { text: props.items?.doctorFullName || "-", x: 419, y: 779 },
      { text: props.items?.ipd_room, x: 536, y: 779 },
      { text: truncateText(props.items?.allergies, customFont, fontSize, 384, 580), x: 384, y: 764 }
    ];

    drawTextOnPage(pages[0], pageOneCoordinates, customFont, fontSize);

    const modifiedPdfBytes = await pdfDoc.save();
    const getAsBase64 = await pdfDoc.saveAsBase64();
    const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
    const modifiedPdfUrl = URL.createObjectURL(blob);

    return { uint8Array: modifiedPdfBytes, blobUrl: modifiedPdfUrl, blobRaw: blob, base64String: getAsBase64 }

  } catch (error) {
    console.error("Error modifying PDF: ", error);
    return {};
  }
};

export default FormGraphicSheet;